module.exports = __webpack_public_path__ + "img/b-5.8a09c9d8.png";